import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import _ from "lodash";
import { showNotification } from "Common/utils/Notification";
import BreadCrumb from "Common/BreadCrumb";
import { CATEGORY_ADD_ROUTE,CATEGORY_LIST_ROUTE } from "constants/routeEnum";
import { ToastContainer } from "react-toastify";
import LoaderComponent from "Common/Components/Loader/Loader";

const AddCategory = () => {
  const navigate = useNavigate();
  const [buttons, setButtons] = useState<any>([]);
  const [loader, setLoader] = useState<any>(false);
  const [headerText, setHeaderText] = useState<any>();

  const [errors, setErrors] = useState<any>({
    banner_header_text: "",

    buttons: buttons?.map(() => ({ label: "", value: "" })),
  });



  const handleSave = async () => {
    const newErrors = {
      banner_header_text:
        headerText.trim() === "" ? "Please enter a banner header." : "",
    };

    setErrors(newErrors);

    if (
      !newErrors.banner_header_text 
    ) {
      try {
        setLoader(true);
        const res = await callApi(`v1/category/new`, "post", 
          {
            category: {
              name: headerText,
              slug: _.kebabCase(headerText),
            }
          });
        setLoader(false);
        if (res && res?.status === "Success") {
          showNotification("Content added successfully!", "success");

          navigate(CATEGORY_LIST_ROUTE);
        } else {
          showNotification("Something went wrong. Please try again.", "error");
          setLoader(false);
        }
      } catch (e) {
        showNotification("An error occurred . Please try again.", "error");
        setLoader(false);
      }
    }
  };

  return (
    <>
      <BreadCrumb
        title={CATEGORY_ADD_ROUTE}
        pageTitle={CATEGORY_LIST_ROUTE}
        version="v1"
      />
      <ToastContainer />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-6">
            {/* <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <div className="mb-4 xl:col-span-12"> */}
            <label className="inline-block mb-2 text-base font-medium">
              Enter Category
            </label>
            <input
              type="text"
              className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
              placeholder="Enter Category Name"
              value={headerText}
              onChange={(e) => {
                setErrors((prev) => ({
                  ...prev,
                  ["banner_header_text"]: "",
                }));
                setHeaderText(e.target.value);
              }}
            />
            {errors.banner_header_text && (
              <p className="text-red-500">{errors.banner_header_text}</p>
            )}

            {/* Save Button */}
            <div className="flex justify-end gap-2 mt-4">
              <button
                onClick={() => handleSave()}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                {loader ? <LoaderComponent /> : " Save"}
              </button>

              <Link
                className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                to={CATEGORY_LIST_ROUTE}
              >
                cancel
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCategory;
